import { VtmnTag } from '@vtmn/react';
import './modelAccordionHeader.scss';

interface ModelAccordionHeaderProps {
  picture: string;
  smId: string;
  label: string;
  nbModels: number;
}
export const ModelAccordionHeader = ({
  picture,
  smId,
  label,
  nbModels,
}: ModelAccordionHeaderProps) => {
  return (
    <div
      data-testid="model-accordion_header"
      className="model-accordion-header"
    >
      <div className="vtmn-flex vtmn-gap-2">
        <img
          src={picture}
          alt="sm-description"
          height={30}
          width={40}
          data-testid="model-accordion_header_picture"
        />
        <div className="model-accordion-sm-details">
          <p className="sm-id">{smId}</p>
          <p>{label}</p>
        </div>
      </div>
      <VtmnTag variant="decorative_gravel" className="vtmn-mr-6">
        {`${nbModels} models`}
      </VtmnTag>
    </div>
  );
};
